import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const FlashcardContext = createContext();

export function useFlashcards() {
  return useContext(FlashcardContext);
}

export function FlashcardProvider({ children }) {
  const { user } = useAuth();
  const [flashcards, setFlashcards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load flashcards from localStorage on component mount
  useEffect(() => {
    if (user) {
      const savedFlashcards = localStorage.getItem(`flashcards_${user.uid}`);
      if (savedFlashcards) {
        setFlashcards(JSON.parse(savedFlashcards));
      }
    }
    setLoading(false);
  }, [user]);

  // Save flashcards to localStorage whenever they change
  useEffect(() => {
    if (user && flashcards.length > 0) {
      localStorage.setItem(`flashcards_${user.uid}`, JSON.stringify(flashcards));
    }
  }, [flashcards, user]);

  const createFlashcard = (flashcard) => {
    const newFlashcard = {
      id: Date.now().toString(),
      ...flashcard,
      createdAt: new Date().toISOString(),
      userId: user.uid
    };
    setFlashcards(prev => [...prev, newFlashcard]);
  };

  const updateFlashcard = (id, updatedFlashcard) => {
    setFlashcards(prev =>
      prev.map(flashcard =>
        flashcard.id === id ? { ...flashcard, ...updatedFlashcard } : flashcard
      )
    );
  };

  const deleteFlashcard = (id) => {
    setFlashcards(prev => prev.filter(flashcard => flashcard.id !== id));
  };

  const getFlashcardsByCategory = (category) => {
    return flashcards.filter(flashcard => flashcard.category === category);
  };

  const value = {
    flashcards,
    loading,
    error,
    createFlashcard,
    updateFlashcard,
    deleteFlashcard,
    getFlashcardsByCategory
  };

  return (
    <FlashcardContext.Provider value={value}>
      {children}
    </FlashcardContext.Provider>
  );
} 